import {Fragment, h} from 'preact';
import {Router} from 'preact-router';
import "flowbite/dist/flowbite.min.js";

import {useApp} from "./useApp";

// Code-splitting is automated for `routes` directory
import Home from '../routes/Home/';
import LoginPage from '../routes/LoginPage/';
import RegisterPage from '../routes/RegisterPage/';
import PasswordForgot from '../routes/PasswordForgot/';
import PasswordChange from '../routes/PasswordChange/';
import Checkout from "../routes/Checkout";
import Cms from "../routes/Cms";
import OrderResult from "../routes/OrderResult";
import OrderPix from "../routes/OrderPix";
import UserOrderDetails from '../routes/UserOrderDetails/userOrderDetails';
import Contact from "../routes/Contact";
import Search from "../routes/Search";
import UserAccount from "../routes/UserAccount";
import UserAddresses from "../routes/UserAddresses";
import UserOrders from "../routes/UserOrders";
import UserBeneficiaries from "../routes/UserBeneficiaries";
import UserPassword from "../routes/UserPassword";
import Terms from "../routes/Terms";
import Questions from "../routes/Questions";
import PrivacyPolicy from "../routes/PrivacyPolicy";
import NotFound from '../routes/NotFound';
import NadFlow from "../routes/NadFlow";

import {
    ContextsWrapper,
    Footer,
    Header,
    TinyFooter,
    TinyHeader,
    FullPageLoader,
    LocationPickerModal,
    NewsletterModal,
    FullPageLoaderV2, ErrorBadge, SuccessBadge
} from './';
import SiteMap from '../routes/SiteMap';
import Error from "../routes/Error";
import Onboarding from "../routes/Onboarding";

const App = () => {
    // General app props
    const appProps = useApp();

    // Destructured general app props
    const {
        isSpecialPath,
        pathLocation,
        handleRouteChange
    } = appProps;

    // The below variables store its respective components
    // according to the path location in which the user is at
    const header = isSpecialPath !== null ? (
        !isSpecialPath ? <Header /> : <TinyHeader />
    ) : null;
    const footer = isSpecialPath !== null ? (
        !isSpecialPath ? <Footer /> : <TinyFooter />
    ) : null;

    // Formats the current pathname without any parameters it may have
    const rawPathName = pathLocation.split("?")[0];

    // Checks if user is checking out
    const isCheckout = rawPathName === "/checkout";
    // Checks if user is at the nad feature page
    const isNad = rawPathName === "/nad";

    // All store loader components
    const loaders = (
        <Fragment>
            <FullPageLoader />
            <FullPageLoaderV2 />
        </Fragment>
    );

    // All the modals that should be displayed at page load time
    const globalModals = !isCheckout ? (
        <Fragment>
            <LocationPickerModal />
            <NewsletterModal />
        </Fragment>
    ) : null;

    // That's it!
    const applicationAlerts = (
        <Fragment>
            <ErrorBadge mode={"new"} />
            <SuccessBadge mode={"new"} />
        </Fragment>
    );

    return (
        <div id="app" className={"min-h-screen items-stretch flex flex-col justify-between relative"}>
            <ContextsWrapper>
                {loaders}
                {globalModals}
                {/**
                 * TODO: We're fully aware that this is quite a workaround and definitely must be rethought.
                 *  Both architecture and code duplicity issues here, but it was the only method we could conceive of
                 *  to center the login page content along the vertical view port axis.
                 * */}
                {(!isCheckout && !isNad && rawPathName === "/entre") && header}
                <div className={"relative h-full"}>
                    {(!isCheckout && !isNad && rawPathName !== "/entre") && header}
                    <main>
                        {applicationAlerts}
                        <Router onChange={e => handleRouteChange(e.url)}>
                            {/* Basic routes */}
                            <Home path="/" />
                            <Home path="/home" />
                            <Cms path="/:path/:rest?*" pathLocation={pathLocation} />
                            <Search path={"/busca"} />
                            <NadFlow path={"/nad"} />
                            <Checkout path={"/checkout/:rest?*"} />
                            <OrderPix path={"/order/pix"} />
                            <OrderResult path={"/order/:path"} />

                            {/* User actions section */}
                            <LoginPage path={"/entre/:rest?*"} />
                            <RegisterPage path={"/criar-conta/:rest?*"} />
                            <RegisterPage path={"/finalizar-cadastro/:rest?*"} />
                            <PasswordForgot path={"/esqueci-a-senha/:rest?*"} />
                            <PasswordChange path={"/mudar-senha/:rest?*"} />

                            {/* User logged in area */}
                            <UserAccount path={"/editar-conta"} />
                            <UserAddresses path={"/enderecos"} />
                            <UserOrders path={"/meus-pedidos"} />
                            <UserOrderDetails path={"/meus-pedidos/:id"} />
                            <UserBeneficiaries path={"/beneficiarios"} />
                            <UserPassword path={"/senha"} />

                            {/* CMS pages */}
                            <Contact path={"/fale-conosco"} />
                            <Terms path={"/termos-de-uso"} />
                            <Questions path={"/perguntas-frequentes"} />
                            <PrivacyPolicy path={"/politica-de-privacidade"} />
                            
                            {/* Static content pages */}
                            <SiteMap path={"/mapa-do-site"} />

                            {/* Fallback pages */}
                            <NotFound path={"/not-found"} />
                            <Error path={"/error"} />

                            {/* General pages */}
                            <Onboarding path={"/onboarding"} />
                        </Router>
                    </main>
                </div>
                {footer}
            </ContextsWrapper>
        </div>
    );
}

export default App;
